import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Grid from '@material-ui/core/Grid';

import { get } from 'utils/lodash';
import { getActionItems, getStatusMessage } from 'utils/self-unlock';
import { USER_STATUS_DISABLED, USER_STATUS_ENABLED, USER_STATUS_LOCKED, USER_STATUS_NORMAL } from 'settings/constants/self-unlock';

import { Select, Textfield, TextLabel } from 'components/common';

const UnlockForm = ({ verifiedDetail, selectedAction, handleChange }) => {
  const { formatMessage } = useIntl();

  const userStatus = get(verifiedDetail, 'userStatus', '');

  const isDisabled = userStatus === USER_STATUS_DISABLED;
  const isNormal = userStatus === USER_STATUS_NORMAL;
  const isEnabled = userStatus === USER_STATUS_ENABLED;

  const statusMessage = getStatusMessage(userStatus);
  const actionItems = getActionItems(isNormal, isEnabled);

  return (
    <>
      <Grid container spacing={1} alignItems="center" className="form-spacing">
        <Grid item xs={12} sm={5}>
          <TextLabel label={formatMessage({ id: 'selfUnlock.modal.unlock.status' })} />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Textfield disabled readOnly value={formatMessage(statusMessage)} />
        </Grid>
      </Grid>

      {!isDisabled && (
        <Grid container spacing={1} alignItems="center" className="form-spacing">
          <Grid item xs={12} sm={5}>
            <TextLabel label={formatMessage({ id: 'selfUnlock.modal.unlock.action' })} />
          </Grid>
          <Grid item xs={12} sm={7}>
            <Select
              id="reset_using"
              fullWidth
              options={actionItems}
              value={selectedAction}
              onChange={e => handleChange('selectedAction', e.target.value)}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

UnlockForm.propTypes = {
  verifiedDetail: PropTypes.object.isRequired,
  selectedAction: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default UnlockForm;
